module.exports = __webpack_public_path__ + "media/images/app/testimonials/reviews/alhambra_green_earrings-8d8a9a6d291d4e421eee7aa0134bb848.webp";